import React from 'react';
import { Link } from 'gatsby';
import logo from '../img/pulse-logo.svg';

const Navbar = class extends React.Component {
  render() {
    return (
      <nav
        className="navbar is-transparent"
        role="navigation"
        aria-label="main-navigation"
      >
        <div className="container">
          <div className="navbar-brand">
            <Link to="/" className="navbar-item" title="Logo">
              <img src={logo} alt="Pulse 400 KW" style={{ width: '200px' }} />
            </Link>
          </div>
        </div>
      </nav>
    );
  }
};

export default Navbar;
